
export const portfolioBlotterPromptHead = `
Describe the changes in the portfolio as they occur. Start with the first 2 snapshots explaining the change in the 
portfolio based on the holdings and what this means for the portfolio. For any subsequent snapshots, explain the changes
here as well ensuring that for each snapshot date from 2 to the end, you explain the changes in the portfolio in a way
that showcases the expertise and value provided by the financial advisors, ensuring we focus on things in the movement
that benefited the client. Please format each snapshot so that it is wrapped like this example ---...---, so we can
parse by snapshot summary. For example:

---Snapshot (2020-06-18)---
[Description of the snapshot]

---Snapshot (2021-05-07)---
[Description of the snapshot]
`

